<template>
  <div class="registration-form">
    <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
      <form class="uk-form-stacked" role="form">
        <div class="uk-grid" uk-grid>
          <div class="uk-width-1-1">
            <div class="uk-margin">
              <label class="uk-form-label">Firma*</label>
              <div class="uk-form-controls">
                <ValidationProvider :rules="'required'" name="company" v-slot="{ errors }">
                  <input
                    class="uk-input"
                    :class="{ 'uk-form-danger': errors[0] }"
                    name="company"
                    type="text"
                    v-model="form.company"
                  />
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div class="uk-width-1-2@m">
            <div class="uk-margin">
              <label class="uk-form-label">Anrede*</label>
              <div class="uk-form-controls">
                <ValidationProvider :rules="'required'" name="salutation" v-slot="{ errors }">
                  <select
                    id="salutation"
                    class="uk-select uk-display-block"
                    :class="{ 'uk-form-danger': errors[0] }"
                    v-model="form.salutation"
                  >
                    <option value>Bitte wählen</option>
                    <option value="Herr">Herr</option>
                    <option value="Frau">Frau</option>
                    <option value="Prof.">Prof.</option>
                    <option value="Dr.">Dr.</option>
                  </select>
                </ValidationProvider>
              </div>
            </div>
            <div class="uk-margin">
              <label class="uk-form-label">Vorname*</label>
              <div class="uk-form-controls">
                <ValidationProvider :rules="'required'" name="firstname" v-slot="{ errors }">
                  <input
                    class="uk-input"
                    :class="{ 'uk-form-danger': errors[0] }"
                    type="text"
                    name="firstname"
                    v-model="form.firstname"
                  />
                </ValidationProvider>
              </div>
            </div>
            <div class="uk-margin">
              <label class="uk-form-label">Nachname*</label>
              <div class="uk-form-controls">
                <ValidationProvider :rules="'required'" name="lastname" v-slot="{ errors }">
                  <input
                    class="uk-input"
                    :class="{ 'uk-form-danger': errors[0] }"
                    type="text"
                    name="lastname"
                    v-model="form.lastname"
                  />
                </ValidationProvider>
              </div>
            </div>
            <div class="uk-margin">
              <label class="uk-form-label">Straße*</label>
              <div class="uk-form-controls">
                <ValidationProvider :rules="'required'" name="street" v-slot="{ errors }">
                  <input class="uk-input" :class="{ 'uk-form-danger': errors[0] }" type="text" v-model="form.street" name="street" />
                </ValidationProvider>
              </div>
            </div>
            <div class="uk-margin">
              <div class="uk-grid uk-grid-small" data-uk-grid>
                <div class="uk-width-small@m">
                  <label class="uk-form-label">PLZ*</label>
                  <div class="uk-form-controls">
                    <ValidationProvider :rules="'required'" name="zipcode" v-slot="{ errors }">
                      <input
                        class="uk-input"
                        :class="{ 'uk-form-danger': errors[0] }"
                        type="text"
                        name="zipcode"
                        v-model="form.zipcode"
                      />
                    </ValidationProvider>
                  </div>
                </div>
                <div class="uk-width-expand">
                  <div class="uk-margin">
                    <label class="uk-form-label">Ort*</label>
                    <div class="uk-form-controls">
                      <ValidationProvider :rules="'required'" name="city" v-slot="{ errors }">
                        <input
                          class="uk-input"
                          :class="{ 'uk-form-danger': errors[0] }"
                          type="text"
                          name="city"
                          v-model="form.city"
                        />
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="uk-width-1-2@m">
            <div class="uk-margin">
              <label class="uk-form-label">USt.-Id.Nr. / VAT*</label>
              <div class="uk-form-controls">
                <ValidationProvider :rules="'required'" name="ustid" v-slot="{ errors }">
                  <input class="uk-input" :class="{ 'uk-form-danger': errors[0] }" type="text" v-model="form.ustid" name="ustid" />
                </ValidationProvider>
              </div>
            </div>
            <div class="uk-margin">
              <label class="uk-form-label">Fax</label>
              <div class="uk-form-controls">
                <input class="uk-input" name="fax" type="text" v-model="form.fax" />
              </div>
            </div>
            <div class="uk-margin">
              <label class="uk-form-label">Telefon*</label>
              <div class="uk-form-controls">
                <ValidationProvider :rules="'required'" name="phone" v-slot="{ errors }">
                  <input class="uk-input" :class="{ 'uk-form-danger': errors[0] }" type="text" v-model="form.phone" name="phone" />
                </ValidationProvider>
              </div>
            </div>
            <div class="uk-margin">
              <label class="uk-form-label">E-Mail*</label>
              <div class="uk-form-controls">
                <ValidationProvider :rules="'required'" name="email" v-slot="{ errors }">
                  <input
                    class="uk-input uk-display-block"
                    :class="{ 'uk-form-danger': errors[0] }"
                    type="email"
                    name="email"
                    v-model="form.email"
                  />
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div class="uk-width-1-1" v-if="showFileUploads">
            <div class="uk-grid" data-uk-grid>
              <div class="uk-width-1-3@m">
                <div class="uk-card uk-card-default uk-card-small">
                  <ValidationProvider :rules="'required'" name="business_registration" v-slot="{ errors }">
                    <div class="uk-card-header border-top" :class="{ 'uploadDanger bg': errors[0] }">{{ businessRegistrationLabel }}</div>
                    <div class="uk-card-body" :class="{ uploadDanger: errors[0] }">
                      <div class="uk-margin">
                        <file-upload
                          :id="0"
                          url="https://api.descpro.de/b2b/merchant/register/upload"
                          type="business_registration"
                          v-model="form.business_registration"
                        ></file-upload>
                      </div>
                    </div>
                  </ValidationProvider>
                </div>
              </div>
              <div class="uk-width-1-3@m">
                <div class="uk-card uk-card-default uk-card-small">
                  <ValidationProvider :rules="'required'" name="identity_card" v-slot="{ errors }">
                    <div class="uk-card-header border-top" :class="{ 'uploadDanger bg': errors[0] }">Personalausweis GF</div>
                    <div class="uk-card-body" :class="{ uploadDanger: errors[0] }">
                      <div class="uk-margin">
                        <file-upload
                          :id="0"
                          url="https://api.descpro.de/b2b/merchant/register/upload"
                          type="identity_card"
                          v-model="form.identity_card"
                        ></file-upload>
                      </div>
                    </div>
                  </ValidationProvider>
                </div>
              </div>
              <div class="uk-width-1-3@m" v-if="tenant.knumber === 'K10149'">
                <div class="uk-card uk-card-default uk-card-small">
                  <ValidationProvider :rules="'required'" name="ustid_registration" v-slot="{ errors }">
                    <div class="uk-card-header border-top" :class="{ 'uploadDanger bg': errors[0] }">USt-ID Nachweis</div>
                    <div class="uk-card-body" :class="{ uploadDanger: errors[0] }">
                      <div class="uk-margin">
                        <file-upload
                          :id="0"
                          url="https://api.descpro.de/b2b/merchant/register/upload"
                          type="ustid_registration"
                          v-model="form.ustid_registration"
                        ></file-upload>
                      </div>
                    </div>
                  </ValidationProvider>
                </div>
              </div>
            </div>
          </div>
          <div class="uk-width-1-1">
            <p class="uk-text-small">
              Bitte beachten Sie, dass die Freischaltung Ihres Händlerzugangs erst nach der vollständigen Prüfung Ihrer
              Angaben sowie der Ust.-Id Nr. erfolgt.
              <br /><br />* Plichtfelder
            </p>
          </div>
          <div class="uk-width-1-1">
            <div class="uk-margin">
              <ValidationProvider :rules="'required'" name="privacy" v-slot="{ errors }">
                <label class="uk-margin-remove" :class="{ 'uk-form-danger': errors[0] }">
                  <input type="checkbox" class="uk-checkbox" v-model="privacy" />
                  <span class="uk-text-small">
                    Mit der Verarbeitung meiner Daten, wie in der
                    <a :href="tenant.privacyLink" target="_blank">Einwilligungserklärung</a> beschrieben stimme Ich zu.
                    Ich kann diese Einwilligung jederzeit mit Wirkung für die Zukunft wiederufen.*</span
                  >
                </label>
              </ValidationProvider>
            </div>
          </div>
        </div>
        <div class="uk-grid" uk-grid>
          <div class="uk-width-1-1">
            <div class="uk-text-right">
              <div v-if="success">
                <p class="uk-text-success">Registrierung erfolgreich abgeschlossen!</p>
              </div>
              <div v-if="emailAvailable">
                <p class="uk-text-danger">Diese E-Mail-Adresse ist bereits registriert!</p>
              </div>
              <button
                @click.prevent="handleSubmit(submit)"
                type="submit"
                class="uk-margin-top uk-button uk-button-secondary send-button"
                :disabled="sending"
              >
                <i :class="{ 'fa fa-spin fa-refresh': sending }"></i>
                Absenden
              </button>
            </div>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import FileUpload from './FileUpload.vue'
import { mapActions, mapGetters } from 'vuex'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { required, confirmed, min } from 'vee-validate/dist/rules'

extend('required', {
  ...required,
  message: 'Pflichtfeld'
})

extend('confirmed', {
  ...confirmed
})

extend('min', {
  ...min
})
export default {
  data() {
    return {
      form: {
        company: '',
        street: '',
        zipcode: '',
        city: '',
        country: '',
        salutation: '',
        ustid: '',
        firstname: '',
        lastname: '',
        phone: '',
        mobile: '',
        fax: '',
        email: '',
        identity_card: '',
        business_registration: '',
        ustid_registration: ''
      },
      countries: [
        'Deutschland',
        'Österreich',
        'Schweiz',
        'Belgien',
        'Polen',
        'Dänemark',
        'Bulgarien',
        'Estland',
        'Finnland',
        'Frankreich',
        'Griechenland',
        'Grossbritannien',
        'Holland',
        'Italien',
        'Irland',
        'Kroatien',
        'Lettland',
        'Litauen',
        'Luxemburg',
        'Malta',
        'Norwegen',
        'Portugal',
        'Rumänien',
        'Schweden',
        'Slowakei',
        'Slowenien',
        'Spanien',
        'Tschechien',
        'Ungarn',
        'Zypern'
      ],
      privacy: '',
      sending: false,
      success: false,
      submitted: false,
      emailAvailable: false
    }
  },

  components: {
    FileUpload,
    ValidationProvider,
    ValidationObserver
  },

  mounted() {},
  computed: {
    ...mapGetters({ tenant: 'tenant' }),
    showFileUploads() {
      return this.tenant.knumber === 'K10149' || this.tenant.knumber === 'K10167' || this.tenant.knumber === 'K10166'
    },
    businessRegistrationLabel () {
      if(this.tenant.knumber === 'K10167') {
        return 'Handelsregister oder Gewerbeanmeldung'
      }

      return 'Handelsregister'
    }
  },
  methods: {
    ...mapActions({
      register: 'auth/register'
    }),
    async submit() {
      this.sending = true
      this.emailAvailable = false
      try {
        const response = await this.register({
          payload: this.form,
          context: this
        })
        if (response.data.status) {
          //show success
          this.success = true
          this.sending = false
          // set timeout
          this.$emit('completed')
        } else {
          this.emailAvailable = true
          this.success = false
          this.sending = false
        }
      } catch (error) {
        // show error
        this.sending = false
      }
    }
  }
}
</script>
